import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const DifficultyBadge = ({ difficulty }: { difficulty: number }) => {
  const variant =
    difficulty >= 8
      ? "bg-danger text-white"
      : difficulty >= 6
      ? "bg-warning text-dark"
      : difficulty >= 3
      ? "bg-secondary text-white"
      : "bg-success text-white";

  return <span className={`badge ${variant}`}>{difficulty}/10</span>;
};

export const navigateToExerciseFilePreSignedUrl = (exercise_id: number, language: string) => {
  ApiService.get(`exercises/${exercise_id}/file/link`)
    .then((response) => {
      const link = response.data.exercise_file_link;

      if (link === "") {
        alert(translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.ERROR.FETCH_FILE_LINK"));
      } else {
        window.open(link, "_blank");
      }
    })
    .catch((err) => {
      console.error("An error occurred during exercise file pre-signed url generation", err);
      alert(translate(language, "ERROR.API_ERROR"));
    });
};

export const removeExerciseResources = (
  exerciseId: number,
  setRemoving: Function,
  onSuccess: Function,
  language: string
) => {
  setRemoving(true);
  ApiService.patch(`exercises/${exerciseId}`, {
    required_cpu: null,
    required_memory: null,
    required_ephemeral_storage: null,
  })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating exercise resources:", error);
      alert(translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.ERROR.UPDATE_EXERCISE_RESOURCE"));
    })
    .finally(() => setRemoving(false));
};
